import { ObjetKStatus, enumValue } from '@siclop/kstone-vue'
import { ProjectStatus } from '../enums'
import { DisplayUnit } from '@/modules/estimation/enums'
import type { Lot } from '@/modules/lot/models/Lot'
import type { Activity } from '@/modules/activity/models/Activity'
import type { Quote } from '@/modules/quote/models/Quote'
import type { Invoice } from '@/modules/invoice/models/Invoice'

export class Project extends ObjetKStatus {
  code: string = ''
  name: string = ''
  description: string = ''
  customerId: number = 0
  customerName?: string
  projectTypeId: number = 0
  projectTypeName?: string
  projectState: ProjectStatus = ProjectStatus.Draft
  startDate?: Date
  plannedEndDate?: Date
  actualEndDate?: Date
  estimatedCost: number = 0
  /** Coût réel : heures × taux de revient salarial (somme des activités, calculée par l'API). */
  actualCost: number = 0
  /** Valorisé : heures × tarif de facturation (somme des montants des activités, calculée par l'API). */
  valuedCost: number = 0
  gitLabProjectId?: number
  gitLabUrl?: string
  notes: string = ''
  rootFolderId?: number
  defaultDisplayUnit: DisplayUnit = DisplayUnit.Hours
  lots?: Lot[]
  activities?: Activity[]
  quotes?: Quote[]
  invoices?: Invoice[]

  constructor(data?: Partial<Project>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.name = data.name ?? ''
      this.description = data.description ?? ''
      this.customerId = data.customerId ?? 0
      this.customerName = data.customerName
      this.projectTypeId = data.projectTypeId ?? 0
      this.projectTypeName = data.projectTypeName
      this.projectState = enumValue(ProjectStatus, data.projectState, ProjectStatus.Draft)
      this.startDate = data.startDate ? new Date(data.startDate) : undefined
      this.plannedEndDate = data.plannedEndDate ? new Date(data.plannedEndDate) : undefined
      this.actualEndDate = data.actualEndDate ? new Date(data.actualEndDate) : undefined
      this.estimatedCost = data.estimatedCost ?? 0
      this.actualCost = data.actualCost ?? 0
      this.valuedCost = data.valuedCost ?? 0
      this.gitLabProjectId = data.gitLabProjectId
      this.gitLabUrl = data.gitLabUrl
      this.notes = data.notes ?? ''
      this.rootFolderId = data.rootFolderId
      this.defaultDisplayUnit = enumValue(DisplayUnit, data.defaultDisplayUnit, DisplayUnit.Hours)
    }
  }
}
